import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "font-small pt-3 fixed-bottom",
  style: {"margin-top":"20px"}
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div id=\"footer\" class=\"footer_style\"><div class=\"container-fluid container_footer bt-space\"><div><span class=\"footer_copyright\">Copyright © 2022 <a href=\"https://simsol.in\" target=\"_SEJ\" rel=\"”noreferrer”\"> SimSol Technologies and Services Private Limited </a> | All Rights Reserved. </span></div><div class=\"footer_copyright\" id=\"page_load\"></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, _hoisted_3))
}